import { ChromeTooltipWidget } from '@tableau/widgets';
import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from '../../CommonStyles';

const cellStyle = _.extend({ cursor: 'default' }, CommonStyles.Layout.FlexBlockLeftAndCenter);

const countStyle = {
  color: CommonStyles.Colors.Grey153,
  flex: 'none',
  marginLeft: CommonStyles.Sizes.DefaultSpace
};

const clickableCountStyle = { cursor: 'pointer' };

export const CellWithCount: React.SFC<CellWithCount.Props>
    = function CellWithCountPill(props: CellWithCount.Props) {
  return (
    <span data-tb-test-id={props.testId} style={cellStyle}>
      {props.children}
      {props.count &&
        <span onClick={props.onCountClick}
              style={_.extend({}, countStyle, props.onCountClick && clickableCountStyle)}
              data-tb-test-id="data-grid-cell-count">
          {props.count}
        </span>
      }
    </span>
  );
};

export const CellWithCountAndToolTip: React.SFC<CellWithCount.Props>
    = function CellWithCountAndToolTip(props: CellWithCount.Props) {

  const tooltipSize = 300;
  return (
    <span data-tb-test-id={props.testId} style={cellStyle}>
      {props.children}
      {props.count &&
        <ChromeTooltipWidget getContent={props.getPopoverContent} width={tooltipSize} defaultSide="Right">
          <span onClick={props.onCountClick}
                style={_.extend({}, countStyle, props.onCountClick && clickableCountStyle)}
                data-tb-test-id="data-grid-cell-count">
            {props.count}
          </span>
        </ChromeTooltipWidget>
      }
    </span>
  );
};

export namespace CellWithCount {
  export interface Props extends React.Props<any> {
    count?: string;
    testId?: string;
    onCountClick?: () => void;
    getPopoverContent?: () => Promise<JSX.Element>;
  }
}
